<template>
  <div style="padding: 20px">
    <v-card>
      <v-toolbar rounede dense class="white--text" color="indigo" flat>
        <v-toolbar-title>Tempi Squadra</v-toolbar-title>
        <v-spacer></v-spacer>
        <!-- Input della data da -->
        <v-menu
          v-model="calendario_data_da"
          :close-on-content-click="false"
          :nudge-right="40"
          min-width="289"
          transition="scale-transition"
          offset-y
        >
          <template v-slot:activator="{ on }">
            <div
              class="mr-5"
              style="
                border: 1px solid black;
                display: inline-block;
                background-color: white;
                padding: 3px;
              "
            >
              <v-text-field
                background-color="#ffffff"
                class="custom-label-color"
                color="white"
                dense
                hide-details
                label="Data Da"
                v-model="data_da_formattata"
                readonly
                style="max-width: 100px"
                v-on="on"
              >
              </v-text-field>
            </div>
          </template>
          <v-date-picker
            v-model="data_da"
            @input="calendario_data_da = false"
          ></v-date-picker>
        </v-menu>

        <!-- Input della data a -->
        <v-menu
          v-model="calendario_data_a"
          :close-on-content-click="false"
          :nudge-right="40"
          min-width="289"
          transition="scale-transition"
          offset-y
        >
          <template v-slot:activator="{ on }">
            <div
              class="mr-5"
              style="
                border: 1px solid black;
                display: inline-block;
                background-color: white;
                padding: 3px;
              "
            >
              <v-text-field
                background-color="#ffffff"
                class="custom-label-color"
                color="white"
                dense
                hide-details
                label="Data A"
                v-model="data_a_formattata"
                readonly
                style="max-width: 100px"
                v-on="on"
              >
              </v-text-field>
            </div>
          </template>
          <v-date-picker
            v-model="data_a"
            @input="calendario_data_a = false"
          ></v-date-picker>
        </v-menu>

        <!-- Bottone della ricerca -->
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="mr-5"
              @click="getTempiSquadra"
              small
              v-bind="attrs"
              v-on="on"
            >
              <v-icon color="primary"> mdi-magnify </v-icon>
            </v-btn>
          </template>
          <span>Cerca</span>
        </v-tooltip>

        <v-spacer></v-spacer>
        <v-btn
          class="red--text"
          @click="clickChiudi"
          color="blue-grey lighten-5"
          small
        >
          <v-icon>mdi-keyboard-backspace</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <v-row>
          <v-col cols="4" md="2">
            <v-autocomplete
              background-color="#ffffff"
              @change="filtra"
              dense
              hide-details
              :items="items_tempi_squadra_totali"
              item-text="cod_commessa"
              item-value="cod_commessa"
              label="Cod Commessa"
              style="display: inline-block; max-width: 350px"
              v-model="cod_commessa_search"
            >
              <template v-slot:append>
                <v-icon
                  class="ml-2"
                  @click="
                    cod_commessa_search = null;
                    filtra();
                  "
                  color="primary"
                  >{{
                    cod_commessa_search == null
                      ? "mdi-filter"
                      : "mdi-filter-off"
                  }}
                </v-icon>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="4" md="2">
            <v-autocomplete
              background-color="#ffffff"
              @change="filtra"
              dense
              hide-details
              :items="items_tempi_squadra_totali"
              item-text="nominativo"
              item-value="nominativo"
              label="Nome Operatore"
              style="display: inline-block; max-width: 350px"
              v-model="nome_operatore_search"
            >
              <template v-slot:append>
                <v-icon
                  class="ml-2"
                  @click="
                    nome_operatore_search = null;
                    filtra();
                  "
                  color="primary"
                  >{{
                    nome_operatore_search == null
                      ? "mdi-filter"
                      : "mdi-filter-off"
                  }}
                </v-icon>
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>

        <v-data-table
          class="elevation-1"
          :headers="headers_tempi_squadra"
          height="70vh"
          :items="items_tempi_squadra"
        >
          <!-- Bottone di modifica delle dichiarazioni -->
          <template v-slot:[`item.modifica`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="mr-5"
                  @click="clickModificaRiga(item)"
                  small
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="primary"> mdi-pencil </v-icon>
                </v-btn>
              </template>
              <span>Modifica Dichiarazione</span>
            </v-tooltip>
          </template>

          <!-- Colonna della data -->
          <template v-slot:[`item.elimina`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="mr-5"
                  @click="clickElimina(item)"
                  small
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="error"> mdi-close </v-icon>
                </v-btn>
              </template>
              <span>Annulla</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-dialog v-model="rettifica_dialog" width="700px">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Rettifica Fermo
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="salvaRettifica" small v-bind="attrs" v-on="on">
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="chiudiRettificaDialog"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5">
          <v-row>
            <!-- Spazio della commessa -->
            <v-col cols="3" align="center">
              <v-text-field
                dense
                hide-details
                label="Commessa"
                readonly
                style="max-width: 150px"
                v-model="riga_sel.cod_commessa"
              ></v-text-field>
            </v-col>

            <!-- Spazio della descrizione della fase -->
            <v-col cols="3" align="center">
              <v-text-field
                dense
                hide-details
                label="Fase"
                style="max-width: 150px"
                v-model="riga_sel.des_fase"
              ></v-text-field>
            </v-col>

            <!-- Spazio del nominativo -->
            <v-col cols="3" align="center">
              <v-text-field
                dense
                hide-details
                label="Nominativo"
                readonly
                style="max-width: 150px"
                v-model="riga_sel.nominativo"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <!-- Colonna della data inizio -->
            <v-col cols="3">
              <v-menu
                v-model="calendario_data_inizio_modifica"
                :close-on-content-click="false"
                :nudge-right="40"
                min-width="289"
                transition="scale-transition"
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    background-color="#ffffff"
                    dense
                    hide-details
                    label="Data Start"
                    outlined
                    v-model="data_inizio_tmp_formattata"
                    readonly
                    style="border-radius: 0px"
                    v-on="on"
                  >
                  </v-text-field>
                </template>
                <v-date-picker
                  first-day-of-week="1"
                  locale="it"
                  v-model="riga_sel.data_inizio_tmp"
                  @input="calendario_data_inizio_modifica = false"
                ></v-date-picker>
              </v-menu>
            </v-col>

            <!-- Colonna dell'ora inizio -->
            <v-col cols="3">
              <v-menu
                v-model="calendario_ora_inizio_modifica"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                max-width="350px"
                min-width="350px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    dense
                    hide-details
                    v-model="riga_sel.ora_inizio_tmp"
                    label="Ora Start"
                    outlined
                    readonly
                    style="border-radius: 0px"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-time-picker
                  format="ampm"
                  v-model="riga_sel.ora_inizio_tmp"
                  full-width
                  @click:second="calendario_ora_inizio_modifica = false"
                  use-seconds
                ></v-time-picker>
              </v-menu>
            </v-col>

            <!-- Colonna della data fine -->
            <v-col cols="3">
              <v-menu
                v-model="calendario_data_fine_modifica"
                :close-on-content-click="false"
                :nudge-right="40"
                min-width="289"
                transition="scale-transition"
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    background-color="#ffffff"
                    dense
                    hide-details
                    label="Data Stop"
                    outlined
                    v-model="data_fine_tmp_formattata"
                    readonly
                    style="border-radius: 0px"
                    v-on="on"
                  >
                  </v-text-field>
                </template>
                <v-date-picker
                  first-day-of-week="1"
                  locale="it"
                  v-model="riga_sel.data_fine_tmp"
                  @input="calendario_data_fine_modifica = false"
                ></v-date-picker>
              </v-menu>
            </v-col>

            <!-- Colonna dell'ora fine -->
            <v-col cols="3">
              <v-menu
                v-model="calendario_ora_fine_modifica"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                max-width="350px"
                min-width="350px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    dense
                    hide-details
                    v-model="riga_sel.ora_fine_tmp"
                    label="Ora Stop"
                    outlined
                    readonly
                    style="border-radius: 0px"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-time-picker
                  format="ampm"
                  v-model="riga_sel.ora_fine_tmp"
                  full-width
                  @click:second="calendario_ora_fine_modifica = false"
                  use-seconds
                ></v-time-picker>
              </v-menu>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di conferma eliminazione dei partner -->
    <v-dialog v-model="dialog_conferma_eliminazione" width="unset">
      <v-card style="max-width: 500px">
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text"> Conferma </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <span style="color: rgb(0, 0, 0); font-size: 18px">
            Confermi di voler annullare il tempo di lavorazione selezionato?
          </span>
          <v-divider class="my-5"></v-divider>
          <v-container>
            <v-row align="center" justify="center">
              <v-col class="my-0 py-0" justify="center" cols="12">
                <v-btn
                  class="mr-5"
                  @click="dialog_conferma_eliminazione = false"
                  small
                >
                  <v-icon color="error"> mdi-close </v-icon>
                </v-btn>

                <v-btn @click="eliminaRiga" small>
                  <v-icon color="success"> mdi-check </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Loader -->
    <v-overlay :value="caricamento_dati">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </div>
</template>
<script>
import moment from "moment/moment";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

class Riga {
  constructor(arg = undefined) {
    if (arg != undefined) {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
      });
    } else {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  }

  // Metodo per resettare tutte le campi
  reset() {
    const campi = this.setCampi();

    campi.forEach((c) => {
      this[c.nome] = c.default_val;
    });
  }

  setCampi() {
    const campi = [
      { nome: "cod_commessa", default_val: "" },
      { nome: "cod_fase", default_val: "" },
      { nome: "data_fine_tmp", default_val: "" },
      { nome: "data_inizio_tmp", default_val: "" },
      { nome: "des_fase", default_val: "" },
      { nome: "id_commessa", default_val: null },
      { nome: "id_commessa_tempi", default_val: null },
      { nome: "id_commessa_tempi_squadra", default_val: null },
      { nome: "id_personale", default_val: null },
      { nome: "nominativo", default_val: "" },
      { nome: "ora_fine_formattata", default_val: "" },
      { nome: "ora_fine_tmp", default_val: "" },
      { nome: "ora_inizio_formattata", default_val: "" },
      { nome: "ora_inizio_tmp", default_val: "" },
      { nome: "validita", default_val: 1 },
    ];

    return campi;
  }
}

export default {
  name: "TabellaTempiSquadra",
  components: { SnackbarQV },
  props: {
    visible: { type: Boolean, default: false },
  },
  computed: {
    data_fine_tmp_formattata() {
      return this.riga_sel.data_fine_tmp != ""
        ? moment(this.riga_sel.data_fine_tmp).format("DD/MM/YYYY")
        : "";
    },
    data_inizio_tmp_formattata() {
      return this.riga_sel.data_inizio_tmp != ""
        ? moment(this.riga_sel.data_inizio_tmp).format("DD/MM/YYYY")
        : "";
    },
    data_a_formattata() {
      return this.data_a != "" ? moment(this.data_a).format("DD/MM/YYYY") : "";
    },
    data_da_formattata() {
      return this.data_da != ""
        ? moment(this.data_da).format("DD/MM/YYYY")
        : "";
    },
  },
  data() {
    return {
      // Variabili d'appoggio
      cod_commessa_search: null,
      data_a: null,
      data_da: null,
      nome_operatore_search: null,
      riga_sel: new Riga(),
      tempi_data_a: "",
      tempi_data_da: "",

      // Modal
      calendario_data_a: false,
      calendario_data_da: false,
      calendario_data_fine_modifica: false,
      calendario_data_inizio_modifica: false,
      calendario_ora_fine_modifica: false,
      calendario_ora_inizio_modifica: false,
      caricamento_dati: false,
      dialog_conferma_eliminazione: false,
      rettifica_dialog: false,

      // Array
      headers_tempi_squadra: [
        {
          text: "Rettifica",
          sortable: false,
          value: "modifica",
          width: "100px",
        },
        {
          text: "id",
          sortable: false,
          value: "id_commessa_tempi_squadra",
        },
        {
          text: "Commessa",
          sortable: false,
          value: "cod_commessa",
        },
        {
          text: "Fase",
          sortable: false,
          value: "cod_fase",
        },
        {
          text: "Fase",
          sortable: false,
          value: "des_fase",
        },
        {
          text: "Nominativo",
          sortable: false,
          value: "nominativo",
        },
        {
          text: "Start",
          sortable: false,
          value: "ora_inizio_formattata",
        },
        {
          text: "Stop",
          sortable: false,
          value: "ora_fine_formattata",
        },
        {
          text: "Stop",
          sortable: false,
          value: "elimina",
          width: "100px",
        },
      ],
      items_causali: new Array(),
      items_tipo_causali: new Array(),
      items_tempi_squadra: new Array(),
      items_tempi_squadra_totali: new Array(),
    };
  },
  methods: {
    chiudiRettificaDialog() {
      this.rettifica_dialog = false;
    },
    clickChiudi() {
      this.$emit("click_chiudi");
    },
    clickElimina(arg) {
      this.riga_sel = new Riga(arg);
      this.dialog_conferma_eliminazione = true;
    },
    clickModificaRiga(arg) {
      this.riga_sel = new Riga(arg);

      this.rettifica_dialog = true;
    },
    eliminaRiga() {
      const riga_tmp = {
        id_commessa_tempi_squadra: this.riga_sel.id_commessa_tempi_squadra,
        validita: 0,
      };

      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setcommessatempisquadra",
          token: localStorage.user_token,
          squadra: [riga_tmp],
          is_consuntivo: 1,
        },
      };

      this.caricamento_dati = true;
      this.dialog_conferma_eliminazione = false;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.caricamento_dati = false;
          if (res.status === 200) {
            this.$refs.SnackbarQV.print(
              "success",
              "La riga è stata annullata."
            );
            this.getTempiSquadra();
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non  stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          this.caricamento_dati = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non  stato possibile salvare i dati."
          );
        });
    },
    filtra() {
      let items_tempi_squadra_tmp = [];
      this.items_tempi_squadra_totali.forEach((elem) => {
        items_tempi_squadra_tmp.push(elem);
      });

      //Filtro il codice Commessa
      if (this.cod_commessa_search != null) {
        // Faccio un array temporaneo
        let res = [];
        // Filtro gli elementi visualizzati dopo i passaggi precedenti
        items_tempi_squadra_tmp.forEach((elem) => {
          if (elem.cod_commessa == this.cod_commessa_search) {
            res.push(elem);
          }
        });
        items_tempi_squadra_tmp = res;
      }

      // Filtro il nome dell'operatore
      if (this.nome_operatore_search != null) {
        // Faccio un array temporaneo
        let res = [];
        // Filtro gli elementi visualizzati dopo i passaggi precedenti
        items_tempi_squadra_tmp.forEach((elem) => {
          if (elem.nominativo == this.nome_operatore_search) {
            res.push(elem);
          }
        });
        items_tempi_squadra_tmp = res;
      }

      this.items_tempi_squadra = [];
      this.items_tempi_squadra = items_tempi_squadra_tmp;
    },
    formatData(arg_data, arg_tipo = "full") {
      if (arg_data == null || arg_data == "") {
        return "N/D";
      } else {
        if (arg_tipo == "full") {
          let strRes = "";
          strRes += arg_data.substr(8, 2);
          strRes += "/";
          strRes += arg_data.substr(5, 2);
          strRes += "/";
          strRes += arg_data.substr(0, 4);
          strRes += " ";
          strRes += arg_data.substr(11, 8);
          return strRes;
        } else if (arg_tipo == "strict") {
          let strRes = "";
          strRes += arg_data.substr(8, 2);
          strRes += "/";
          strRes += arg_data.substr(5, 2);
          strRes += "/";
          strRes += arg_data.substr(0, 4);
          strRes += " ";
          return strRes;
        }
      }
    },
    getTempiSquadra() {
      const data_a_tmp = this.data_a.substr(0, 10);
      const data_da_tmp = this.data_da.substr(0, 10);

      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "gettempisquadra",
          token: localStorage.user_token,
          data_da: data_da_tmp,
          data_a: data_a_tmp,
        },
      };

      this.caricamento_dati = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.caricamento_dati = false;
          if (res.status === 200) {
            this.items_tempi_squadra = res.data.result;
            this.items_tempi_squadra_totali = res.data.result;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        })
        .catch(() => {
          this.caricamento_dati = false;
          this.$refs.SnackbarQV.print(
            "orange",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
        });
    },
    salvaRettifica() {
      const obj_tmp = new Riga(this.riga_sel);
      obj_tmp.ora_inizio = `${this.riga_sel.data_inizio_tmp} ${this.riga_sel.ora_inizio_tmp}`;
      obj_tmp.ora_fine = `${this.riga_sel.data_fine_tmp} ${this.riga_sel.ora_fine_tmp}`;

      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setcommessatempisquadra",
          token: localStorage.user_token,
          is_consuntivo: 1,
          squadra: [obj_tmp],
        },
      };

      this.rettifica_dialog = false;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.riga_sel = new Riga();

            // Stampo una snackbar di conferma
            this.$refs.SnackbarQV.print(
              "success",
              "Rettifica eseguita con successo."
            );

            // Aggiorno i dati
            this.getTempiSquadra();
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile salvare i dati."
            );
          }
        })
        .catch(() => {
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile salvare i dati."
          );
        });
    },
  },
  watch: {
    visible: {
      immediate: true,
      async handler() {},
    },
  },
  mounted() {
    this.data_a = moment().format("YYYY-MM-DD");
    this.data_da = moment().subtract(7, "days").format("YYYY-MM-DD");
    this.getTempiSquadra();
  },
};
</script>
<style>
</style>